<template>
  <div class="preview_page">
    <div _title="面包屑">
      <div class="preview_bread">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ name: 'indexPage' }"
            >素材库首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>小挑</el-breadcrumb-item>
          <el-breadcrumb-item>当前作品</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div _title="主体" class="clearfix">
      <div _title="左侧" class="preview_left">
        <div class="preview_left_block" id="recommend">
          <div _title="标题和预览图" class="preview_info">
            <div _title="第一行" class="preview_info_line preview_info_first">
              <h1 class="preview_info_title">
                <span>{{ fileDetail.categoryName || '小挑' }}</span> {{ fileDetail.name }}
                <p class="h1_p">
                  <em> <i class="iconfont iconai-eye"></i>{{ fileDetail.pv || 0 }} </em>
                  <em> <i class="iconfont iconaixin"></i>{{ fileDetail.laud || 0 }} </em>
                </p>
              </h1>
              <div
                class="preview_info_fav_not"
                v-show="!fileDetail.collect"
                @click="toggleLike()"
              >
                <div class="preview_info_fav_line">
                  <i class="el-icon-star-off"></i>
                  <span class="preview_info_fav_text">收藏</span>
                </div>
              </div>
              <div
                class="preview_info_fav"
                v-show="fileDetail.collect"
                @click="toggleLike()"
              >
                <div class="preview_info_not">
                  <i class="el-icon-star-on"></i>
                  <span class="preview_info_fav_text">已收藏</span>
                </div>
              </div>
            </div>

            <ul>
              <li v-for="(item, index) in imageList" :key="index">
                <div class="m-center-cntr">
                  <div class="t-c">
                    <img
                      class="preview_img_list_item_cover"
                      :src="item"
                      alt=""
                    />
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="preview_left_block" style="padding: 10px">
          <div class="preview_left_like">
            <h6 class="p_left_title">相关推荐</h6>
            <!-- 小挑推荐内容 -->
            <div class="articles-list ppt-list">
              <article
                class="post"
                v-for="(item, index) in recommendList.slice(0, 12)"
                :key="index"
              >
                <div class="inner" @click="jumpToDetail(item)" style="width: 195px">
                  <div class="media-pic">
                    <img
                      :src="item.cover || item.image"
                      width="600"
                      height="400"
                      alt=""
                      class="wp-post-image"
                    />
                  </div>
                  <div class="media-body">
                    <a class="title" :title="item.name">
                      {{ item.name }}
                    </a>
                  </div>
                  <div class="clearfix">
                    <p class="post-meta fr">
                      <em>
                        <i class="iconfont iconai-eye"></i>{{ item.pv }}
                      </em>
                      <em>
                        <i class="iconfont iconaixin"></i>{{ item.laud }}
                      </em>
                    </p>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
      <div _title="右侧" class="preview_right">
        <div class="preview_right_block">
          <div>
            <!-- 下载信息 -->
            <div>
              <h3 class="wb-title">下载信息</h3>

              <!-- 价格信息 -->
              <div v-if="!canDownload">
                <span class="preview_price_title">单 价：</span>
                <span _title="现价">
                  <span class="preview__price">
                    ￥
                    <span _title="现价数值" class="preview_price_final_value">
                      {{ fileDetail.price || 0 }}
                    </span>
                  </span>
                </span>
              </div>

              <!-- 操作按钮 -->
              <div>
                <div
                  class="Downloadnow"
                  @click="buy()"
                  v-show="!canDownload"
                >
                  购买
                </div>
                <div
                  class="Downloadnow"
                  v-show="canDownload"
                  @click="download()"
                >
                  直接下载
                </div>

                <p class="botto_p">
                  <span class="copyinfo_title">温馨提示：</span>
                  <span>建议使用Microsoft Office、WPS打开文件，以避免可能出现的排版错乱问题。</span>
                </p>
                <p class="botto_p">
                  <span class="copyinfo_title">授权范围：</span>
                  <span>可做商用</span>
                </p>
                <p class="botto_p">
                  <span class="copyinfo_title">授权对象：</span>
                  <span class="copy_one">个人</span>
                  <span class="copy_two">高校</span>
                </p>
                <p class="botto_p">
                  <span class="copyinfo_title">版权所有：</span>
                  <span>素材库</span>
                </p>
              </div>
            </div>
            <!-- 文件详情 -->
            <ul class="preview_detail clearfix">
              <li class="preview_detail_item">编号: {{ fileDetail.code }}</li>
              <li class="preview_detail_item">作者: {{ fileDetail.author || '素材库' }}</li>
              <li class="preview_detail_item">页数: {{ fileDetail.pageCount || fileDetail.page || 0 }}页</li>
              <li class="preview_detail_item">格式: {{ fileDetail.format }}</li>
              <li class="preview_detail_item">分类: {{ fileDetail.categoryName }}</li>
              <li class="preview_detail_item">类别: {{ fileDetail.subcategoryName || fileDetail.tag }}</li>
            </ul>
          </div>
        </div>
        <!-- 相关片段 -->
        <div
          class="preview_like_block"
          id="torecommed"
          :class="
            Fixed ? 'preview_like_fixed' : Fixeds ? 'preview_like_bottom' : ''
          "
        >
          <div class="preview_like">
            <h6 class="preview_like_title">相关片段</h6>
            <div class="preview_designer_tab_content clearfix">
              <!-- 小挑相关片段 -->
              <div class="articles-list">
                <div style="text-align: center; padding: 20px; color: #999;">
                  暂无相关片段
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 支付弹窗 -->
    <div class="pay_Popup">
      <el-dialog
        title="购买文档"
        :visible.sync="dialogVisible"
        width="780px"
        :before-close="handleClose"
        :show-close="false"
      >
        <i
          class="el-icon-close closei"
          @click="closei()"
          v-show="pay_num != 2"
        ></i>
        <div v-show="pay_num == 1 && showtime == false">
          <div class="muban_detail">
            <p class="name"><i class="line"></i>{{ orderInfo.title || fileDetail.name || '购买文档' }}</p>
            <p class="ordernum">交易订单：{{ orderInfo.number }}</p>
            <p class="final_price_wrapper">
              实际支付：
              <span class="final_price">
                <span class="symbol">￥</span> {{ fileDetail.price || 0 }}
              </span>
            </p>
          </div>
          <div class="qrcode_wrapper clearfix">
            <!-- 微信 -->
            <div class="pay-wx fl">
              <div class="wx-ewm">
                <img :src="wxPayCode" alt="" />
              </div>
              <div class="wx-icon">
                <img src="./../../assets/wx-icon.png" alt="" />微信扫码支付
              </div>
            </div>
            <!-- 支付宝 -->
            <div class="pay-zfb fr" @click="paybuy()">
              <div class="zfb-ewm">
                <img src="./../../assets/pay-zfb.png" alt="" />
              </div>
              <div class="pay-zfb-btn">
                <img src="./../../assets/zfb-icon.png" alt="" />去支付宝支付
              </div>
            </div>
          </div>
        </div>
        <!-- 微信支付成功提示 -->
        <div class="Paysuccess" v-show="pay_num == 2">
          <div class="Pay_div">
            <i class="el-icon-check"></i>
          </div>
          <p class="Pay_p1">支付成功</p>
          <p class="Pay_p2">{{ time }}S后自动关闭...</p>
          <p class="Pay_p3" @click="jumps()">立即关闭</p>
        </div>
        <div v-show="showtime == true">
          <div class="mask_bg"></div>
          <div class="loading_wrapper">
            <i></i>
          </div>
        </div>
      </el-dialog>
    </div>
    <BetterLogin :title="title" @childFn="parentFn"></BetterLogin>
  </div>
</template>
<script>
import API from "@/api/api";

export default {
  data() {
    return {
      fileDetail: {}, // 文件详情
      imageList: [], // 图片列表
      recommendList: [], // 推荐列表
      wxPayCode: "",
      Fixed: 0,
      Fixeds: 0,
      dialogVisible: false,
      title: "",
      orderInfo: {},
      showtime: true,
      time: "",
      pay_num: 1,
      timing: null, // 支付状态轮询定时器
      isAlipayJumping: false, // 标记是否正在跳转支付宝
      // 滚动相关
      floorOne: 0,
      floorTwo: 0,
      offsetHeight: 0,
      reHeight: 0,
      scrollTimer: null // 滚动防抖定时器
    };
  },
  computed: {
    // 计算是否可以下载：已购买
    canDownload() {
      return this.fileDetail.buy === true;
    }
  },
  methods: {
    // 获取文件详情
    async getFileDetail() {
      const code = this.$route.query.code;
      if (!code) {
        this.$message.error('文件编码不能为空');
        return;
      }

      try {
        const token = this.$store.state.token;
        const response = await API.xiaotiaoPreview({
          code: code,
          token: token || ''
        });

        if (response.data && response.data.code === 200 && response.data.data) {
          // 根据文档返回结构，文件信息在data.item中
          const fileData = response.data.data.item;
          this.fileDetail = {
            ...fileData,
            categoryName: response.data.data.categoryName || fileData.categoryName,
            subcategoryName: response.data.data.subcategoryName || fileData.subcategoryName
          };

          // 处理图片列表
          if (this.fileDetail.image) {
            if (typeof this.fileDetail.image === 'string' && this.fileDetail.image.includes(',')) {
              this.imageList = this.fileDetail.image.split(',').map(url => url.trim());
            } else {
              this.imageList = [this.fileDetail.image];
            }
          } else if (this.fileDetail.cover) {
            this.imageList = [this.fileDetail.cover];
          } else {
            this.imageList = [];
          }
        } else {
          console.error('获取文件详情失败:', response.data?.message || '未知错误');
          this.$message.error('获取文件详情失败');
        }
      } catch (error) {
        const errorMsg = error?.message || error?.toString() || '未知错误';
        console.error('获取文件详情失败:', errorMsg, error);
        this.$message.error(`获取文件详情失败: ${errorMsg}`);
      }
    },

    // 获取推荐文件
    async getRecommendFiles() {
      const code = this.$route.query.code;
      if (!code) return;

      try {
        const response = await API.xiaotiaoRecomm({
          code: code
        });

        if (response.data && response.data.code === 200) {
          this.recommendList = response.data.data || [];
        } else {
          console.error('获取推荐文件失败:', response.data?.message || '未知错误');
          this.$message.error('获取推荐文件失败');
        }
      } catch (error) {
        const errorMsg = error?.message || error?.toString() || '未知错误';
        console.error('获取推荐文件失败:', errorMsg, error);
        this.$message.error(`获取推荐文件失败: ${errorMsg}`);
      }
    },

    // 切换收藏状态
    async toggleLike() {
      if (!this.$store.state.token) {
        this.title = true;
        return;
      }

      try {
        const params = {
          token: this.$store.state.token,
          code: this.fileDetail.code,
          state: this.fileDetail.collect ? "f" : "t"  // t=收藏，f=取消收藏
        };

        const response = await API.xiaotiaoLike(params);
        if (response.data && response.data.code === 200) {
          this.fileDetail.collect = !this.fileDetail.collect;

          if (this.fileDetail.collect) {
            this.fileDetail.laud = (this.fileDetail.laud || 0) + 1;
            this.$message.success('收藏成功');
          } else {
            this.fileDetail.laud = Math.max((this.fileDetail.laud || 0) - 1, 0);
            this.$message.success('取消收藏成功');
          }

          this.$forceUpdate();
        } else {
          console.error('收藏操作失败:', response.data?.message || '未知错误');
          this.$message.error('收藏操作失败');
        }
      } catch (error) {
        const errorMsg = error?.message || error?.toString() || '未知错误';
        console.error('收藏操作失败:', errorMsg, error);
        this.$message.error(`收藏操作失败: ${errorMsg}`);
      }
    },

    // 购买 - 创建订单并显示支付弹窗
    async buy() {
      if (!this.$store.state.token) {
        this.title = true;
        return;
      }

      const fileCode = this.fileDetail.code;
      if (!fileCode) {
        this.$message.error('文件信息获取失败，请刷新页面重试');
        return;
      }

      try {
        const params = {
          code: fileCode,
          token: this.$store.state.token
        };

        const response = await API.xiaotiaoOrderTrade(params);
        if (response.data && response.data.code === 200 && response.data.data) {
          this.orderInfo = response.data.data;
          this.dialogVisible = true;
          this.showtime = true;
          this.wxPayCode = "";

          // 获取微信支付二维码（但不立即开始轮询）
          if (response.data.data.payCode) {
            this.wxPayCode = response.data.data.payCode;
            this.showtime = false;
            // 注意：这里不开始轮询，等用户真正扫码后再轮询
            // 但由于无法检测用户是否扫码，所以延迟5秒后开始轮询
            setTimeout(() => {
              if (this.dialogVisible && !this.isAlipayJumping && !this.timing) {
                this.timing = setInterval(() => {
                  this.pay_status();
                }, 2000);
              }
            }, 5000);
          } else {
            // 如果没有返回二维码，显示加载状态
            this.showtime = false;
            this.wxPayCode = 'https://via.placeholder.com/200x200?text=WeChat+Pay+QR';
          }
        } else {
          console.error('创建订单失败:', response.data?.message || '未知错误');
          this.$message.error('创建订单失败');
        }
      } catch (error) {
        const errorMsg = error?.message || error?.toString() || '未知错误';
        console.error('创建订单失败:', errorMsg, error);
        this.$message.error(`创建订单失败: ${errorMsg}`);
      }
    },

    // 查询支付状态（仅用于微信支付）
    async pay_status() {
      // 如果正在跳转支付宝，停止轮询
      if (this.isAlipayJumping) {
        if (this.timing) {
          clearInterval(this.timing);
          this.timing = null;
        }
        return;
      }

      try {
        const params = {
          number: this.orderInfo.number,
          token: this.$store.state.token
        };

        const response = await API.xiaotiaoOrderQuery(params);
        if (response.data && response.data.code === 200 && response.data.data) {
          const orderState = response.data.data.state;
          if (orderState === 2) { // 已支付
            if (this.timing) {
              clearInterval(this.timing);
              this.timing = null;
            }
            // 只有在没有跳转支付宝的情况下才显示成功提示
            if (!this.isAlipayJumping) {
              this.pay_num = 2;
              this.time = 3;
              this.timer();
            }
          }
          // 如果状态不是2，继续轮询
        } else {
          console.error('查询订单状态失败:', response.data?.message || '未知错误');
        }
      } catch (error) {
        const errorMsg = error?.message || error?.toString() || '未知错误';
        console.error('查询订单状态失败:', errorMsg, error);
      }
    },

    // 倒计时
    timer() {
      if (this.time > 0) {
        this.time--;
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.dialogVisible = false;
        if (this.timing) {
          clearInterval(this.timing);
          this.timing = null;
        }
        // 更新文件状态为已购买
        this.fileDetail.buy = true;
        this.$forceUpdate();
      }
    },

    // 跳转到详情页
    jumpToDetail(item) {
      let link = this.$router.resolve({
        name: "SmallChallengeDetail",
        query: { code: item.code }
      });
      window.open(link.href, "_blank");
    },

    // 立即跳转
    jumps() {
      this.dialogVisible = false;
      // 更新文件状态为已购买
      this.fileDetail.buy = true;
      this.$forceUpdate();
    },

    // 下载文件
    async download() {
      try {
        const params = {
          code: this.fileDetail.code
        };

        const response = await API.xiaotiaoDl(params);
        if (response.data && response.data.code === 200 && response.data.data) {
          // 创建下载链接
          const downloadUrl = response.data.data.url;
          if (downloadUrl) {
            window.location.href = downloadUrl;
            this.$message.success('下载成功');
          } else {
            this.$message.error('下载链接获取失败');
          }
        } else {
          console.error('下载失败:', response.data?.message || '未知错误');
          this.$message.error('下载失败');
        }
      } catch (error) {
        const errorMsg = error?.message || error?.toString() || '未知错误';
        console.error('下载失败:', errorMsg, error);
        this.$message.error(`下载失败: ${errorMsg}`);
      }
    },

    // 支付宝支付
    async paybuy() {
      try {
        const params = {
          token: this.$store.state.token,
          number: this.orderInfo.number,
          type: "ali"
        };

        const response = await API.xiaotiaoOrderPay(params);
        if (response.data && response.data.code === 200) {
          // 支付宝返回的HTML表单在message字段中
          const htmlData = response.data.message || response.data.data?.htmlData || response.data.data?.payUrl;
          
          if (!htmlData) {
            this.$message.error('支付宝支付数据获取失败');
            return;
          }
          
          // 标记正在跳转支付宝，停止微信支付轮询
          this.isAlipayJumping = true;
          
          // 关闭当前支付弹窗和轮询
          this.closei();
          
          // 如果是URL，在新窗口打开
          if (typeof htmlData === 'string' && (htmlData.startsWith('http://') || htmlData.startsWith('https://'))) {
            window.open(htmlData, '_blank');
            this.$message.info('请在新窗口完成支付，支付完成后页面将自动更新');
            
            // 开始轮询检查支付状态（用户可能在新窗口完成支付）
            this.startPaymentStatusPolling();
            return;
          }
          
          // 如果是HTML表单，需要在新窗口中提交
          if (typeof htmlData === 'string' && htmlData.includes('<form')) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = htmlData;
            const form = tempDiv.querySelector('form');
            
            if (form) {
              // 验证form的action是否来自支付宝域名
              try {
                const actionUrl = new URL(form.action);
                if (actionUrl.hostname.endsWith('alipay.com') || actionUrl.hostname.endsWith('alipaydev.com')) {
                  // 修改form的target为_blank，在新窗口打开
                  form.target = '_blank';
                  document.body.appendChild(form);
                  form.submit();
                  
                  this.$message.info('请在新窗口完成支付，支付完成后页面将自动更新');
                  
                  // 开始轮询检查支付状态
                  this.startPaymentStatusPolling();
                  
                  // 延迟移除form
                  setTimeout(() => {
                    if (document.body.contains(form)) {
                      document.body.removeChild(form);
                    }
                  }, 100);
                } else {
                  this.$message.error('支付链接不安全');
                  this.isAlipayJumping = false;
                }
              } catch (e) {
                this.$message.error('支付链接格式错误: ' + e.message);
                this.isAlipayJumping = false;
              }
            } else {
              this.$message.error('支付宝支付表单解析失败');
              this.isAlipayJumping = false;
            }
          } else {
            this.$message.error('支付宝支付数据格式错误');
            this.isAlipayJumping = false;
          }
        } else {
          console.error('支付宝支付失败:', response.data?.message || '未知错误');
          this.$message.error('支付宝支付失败');
        }
      } catch (error) {
        const errorMsg = error?.message || error?.toString() || '未知错误';
        console.error('支付宝支付失败:', errorMsg, error);
        this.$message.error(`支付宝支付失败: ${errorMsg}`);
        this.isAlipayJumping = false;
      }
    },

    // 开始轮询支付状态（用于支付宝支付后）
    startPaymentStatusPolling() {
      // 清除可能存在的旧定时器
      if (this.timing) {
        clearInterval(this.timing);
        this.timing = null;
      }
      
      // 每3秒检查一次支付状态
      this.timing = setInterval(async () => {
        try {
          const params = {
            number: this.orderInfo.number,
            token: this.$store.state.token
          };

          const response = await API.xiaotiaoOrderQuery(params);
          if (response.data && response.data.code === 200 && response.data.data) {
            const orderState = response.data.data.state;
            if (orderState === 2) { // 已支付
              // 停止轮询
              if (this.timing) {
                clearInterval(this.timing);
                this.timing = null;
              }
              
              // 重置标记
              this.isAlipayJumping = false;
              
              // 刷新文件详情
              await this.getFileDetail();
              
              // 显示成功提示
              this.$message.success('支付成功！');
            }
          }
        } catch (error) {
          console.error('查询支付状态失败:', error);
        }
      }, 3000);
      
      // 5分钟后自动停止轮询
      setTimeout(() => {
        if (this.timing) {
          clearInterval(this.timing);
          this.timing = null;
          this.isAlipayJumping = false;
          this.$message.info('支付状态检测已超时，如已完成支付请刷新页面，或联系客服处理');
        }
      }, 300000);
    },

    // 关闭弹窗
    closei() {
      this.dialogVisible = false;
      this.pay_num = 1;
      this.showtime = true;
      if (this.timing) {
        clearInterval(this.timing);
        this.timing = null;
      }
    },

    // 登录回调
    parentFn(payload) {
      this.title = payload;
      if (payload === false) {
        if (this.$parent && this.$parent.logintoken) {
          this.$parent.logintoken();
        }
        this.getFileDetail();
        this.getRecommendFiles();
      }
    },

    handleClose(done) {
      console.log(done);
    },

    handleScroll() {
      // 使用 requestAnimationFrame 优化滚动性能
      if (this.scrollTimer) {
        cancelAnimationFrame(this.scrollTimer);
      }
      this.scrollTimer = requestAnimationFrame(() => {
        let scrollTop =
          document.documentElement.scrollTop ||
          window.pageYOffset ||
          document.body.scrollTop;
        
        // 获取文档总高度和窗口高度
        const documentHeight = document.documentElement.scrollHeight;
        const windowHeight = window.innerHeight;
        const scrollBottom = scrollTop + windowHeight;
        
        // 计算相关片段区域的边界
        const obj = document.getElementById("torecommed");
        if (!obj) return;
        
        const floorOne = this.floorOne || obj.offsetTop;
        const floorTwo = this.floorTwo || document.getElementById("recommend")?.offsetTop || 0;
        const offsetHeight = this.offsetHeight || obj.offsetHeight;
        const reHeight = this.reHeight || document.getElementById("recommend")?.offsetHeight || 0;
        
        // 判断是否接近页面底部（留出一些缓冲区域，避免频繁切换）
        const isNearBottom = scrollBottom >= documentHeight - 50;
        
        // 如果接近底部，使用绝对定位
        if (isNearBottom) {
          this.Fixed = false;
          this.Fixeds = true;
          // 计算绝对定位的top值，确保不会超出容器
          const container = obj.offsetParent;
          if (container) {
            const containerTop = container.offsetTop;
            const maxTop = container.offsetHeight - obj.offsetHeight - 20;
            const calculatedTop = Math.min(20, maxTop);
            obj.style.top = calculatedTop + "px";
          } else {
            obj.style.top = "20px";
          }
        } else {
          // 正常滚动区域的处理
          const shouldFixed = scrollTop > floorOne + offsetHeight && scrollTop < floorTwo + reHeight;
          const shouldAbsolute = scrollTop >= floorTwo + reHeight;
          
          // 只在状态真正改变时更新，避免频繁切换
          if (shouldFixed && !this.Fixed) {
            this.Fixed = true;
            this.Fixeds = false;
            obj.style.top = "";
          } else if (shouldAbsolute && !this.Fixeds) {
            this.Fixed = false;
            this.Fixeds = true;
            obj.style.top = "20px";
          } else if (!shouldFixed && !shouldAbsolute) {
            // 回到顶部区域
            this.Fixed = false;
            this.Fixeds = false;
            obj.style.top = "";
          }
        }
      });
    },

    getFloorDis() {
      this.$nextTick(() => {
        setTimeout(() => {
          const obj = document.getElementById("torecommed");
          const recommend = document.getElementById("recommend");
          if (obj) {
            this.floorOne = obj.offsetTop;
            this.offsetHeight = obj.offsetHeight;
          }
          if (recommend) {
            this.floorTwo = recommend.offsetTop;
            this.reHeight = recommend.offsetHeight;
          }
        }, 300);
      });
    }
  },
  async mounted() {
    await this.getFileDetail();
    await this.getRecommendFiles();

    // 检查URL参数，判断是否从支付宝返回
    const urlParams = new URLSearchParams(window.location.search);
    const fromPayment = urlParams.get('from_payment');
    
    // 如果是从支付宝返回，检查订单状态
    if (fromPayment === 'alipay') {
      // 延迟检查，确保支付宝回调已处理
      setTimeout(async () => {
        await this.getFileDetail();
        if (this.fileDetail.buy) {
          this.$message.success('支付成功！');
        }
      }, 1000);
    }

    this.getFloorDis();
    this.$nextTick(function() {
      setTimeout(() => {
        let head = document.getElementById("torecommed");
        this.offsetHeight = head.offsetHeight;
        let heads = document.getElementById("recommend");
        this.reHeight = heads.offsetHeight;
        window.addEventListener("scroll", this.handleScroll);
      }, 500);
    });
  },
  beforeDestroy() {
    if (this.timing) {
      clearInterval(this.timing);
      this.timing = null;
    }
    if (this.scrollTimer) {
      cancelAnimationFrame(this.scrollTimer);
      this.scrollTimer = null;
    }
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
<style scoped>
@import "../../styles/Page/Detailspage.css";
</style>
<style>
.preview_bread .el-breadcrumb {
  line-height: 51px;
}
.preview_bread .el-breadcrumb__inner a:hover,
.el-breadcrumb__inner.is-link:hover {
  color: #666;
}
.preview_bread .el-breadcrumb__inner.is-link {
  color: #666;
}
.pay_Popup .el-dialog {
  height: 500px;
}
.pay_Popup .el-dialog__header {
  padding: 0 50px 0 20px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #3e3e3f;
  position: relative;
  margin: 0;
}
.pay_Popup .el-dialog__title {
  font-size: 14px;
  color: #3e3e3f;
  line-height: 40px;
  height: 40px;
  padding: 0;
  margin: 0;
}
.pay_Popup .el-dialog__body {
  padding: 0;
}
.SmalP_popup .el-dialog__header {
  padding: 0 0 0 0px;
  height: 40px;
  line-height: 40px;
  font-size: 12px;
  color: #3e3e3f;
  border-bottom: 1px solid #eaecee;
}
.SmalP_popup .el-dialog__title {
  font-size: 14px;
  color: #3e3e3f;
}
.SmalP_popup .el-dialog--center .el-dialog__body {
  padding: 25px 25px 15px;
}
</style>

